import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { ContratoUtil } from 'app/main/contrato/store';
import empresaApi from 'app/services/api/empresaApi';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import VisualizarServicoTable from '../visualizar/VisualizarServicoTable';
import { visualizarServicoStyles } from '../visualizar/styles';

const DadosContratoVisualizacao = ({ contrato, getCurrency }) => {
  const [exibeImovel, setExibeImovel] = useState(false);
  const getPeriodoTotal = () => {
    if (contrato?.dataVigenciaInicial && contrato?.dataVigenciaFinal && contrato?.periodicidade === 'MENSAL') {
      return ContratoUtil.calcularPeriodoVigencia(
        moment(contrato.dataVigenciaInicial),
        moment(contrato.dataVigenciaFinal)
      );
    } else if (contrato?.periodicidade === 'ANUAL') {
      return 'Anual';
    }
  };

  const getMunicipioIncidencia = (municipioIncidencia) => {
    switch (municipioIncidencia) {
      case 'TOMADOR':
        return 'Tomador';
      case 'PRESTADOR':
        return 'Prestador';
      default:
        return '-';
    }
  };

  // RNE-1298: o imóvel só é exibido para os códigos de operação IBS/CBS que o exigem no cadastro.
  useEffect(() => {
    const buscarEmpresa = async () => {
      try {
        const response = await empresaApi.buscar(getEmpresaContexto());
        setExibeImovel(ContratoUtil.exigeImovelRelacionado(response?.data?.codigoOperacaoIbsCbs?.codigo));
      } catch (err) {
        console.log(err);
        setExibeImovel(false);
      }
    };

    buscarEmpresa();
  }, []);

  const styles = visualizarServicoStyles();

  return (
    <Grid container spacing={3} className="mb-16" style={{ padding: '16px', maxWidth: '630px' }}>
      <Grid item xs={12}>
        <TextLabel
          id="identificador"
          label="Identificador"
          value={contrato?.identificador?.toString().padStart(3, '0')}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="cliente" label="Cliente" value={contrato?.cliente?.pessoa?.nome} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="vendedor" label="Vendedor" value={contrato?.vendedor?.pessoa?.nome} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="dataVigencia"
          label="Vigência do contrato"
          value={
            contrato?.dataVigenciaInicial &&
            contrato?.dataVigenciaFinal &&
            `${moment(contrato.dataVigenciaInicial).format('DD/MM/YYYY')} a ${moment(contrato.dataVigenciaFinal).format(
              'DD/MM/YYYY'
            )}`
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="periodoTotal" label="Período total" value={getPeriodoTotal()} />
      </Grid>
      <Grid item xs={12}>
        <VisualizarServicoTable id="servicos" label="Serviços" styles={styles} servicos={contrato?.servicos} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="categoria" label="Categoria" value={' '} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="valor" label="Valor bruto (R$)" value={' '} />
      </Grid>
      {contrato?.categorias?.map((categoria) => (
        <Fragment key={categoria?.id}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="categoria" label="" value={`${categoria?.classe?.indice} ${categoria?.classe?.nome}`} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="valorBruto" label="" value={getCurrency(categoria?.valorBruto)} />
          </Grid>
        </Fragment>
      ))}
      {exibeImovel && (
        <Grid item xs={12}>
          <TextLabel id="imovelRelacionado" label="Imóvel relacionado" value={contrato?.imovel?.nome} />
        </Grid>
      )}
      <Grid item xs={12}>
        <TextLabel
          id="municipioIncidencia"
          label="Município da incidência"
          value={getMunicipioIncidencia(contrato?.municipioIncidencia)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="informacoesComplementares"
          label="Informações complementares"
          value={contrato?.informacoesComplementares}
        />
      </Grid>
    </Grid>
  );
};

export default DadosContratoVisualizacao;
